import * as actionTypes from './actionTypes';

export const setSocketData = (data=null,channel=null,timestamp=null) => {
    return {
        type: actionTypes.SOCKETS_DATA,
        data: data,
        channel:channel,
        timestamp:timestamp,
    };
};